import { format, isValid } from "date-fns";

/** Shared date-fns format tokens used across the app. */
export const DATE_FORMAT = {
  DISPLAY: "dd/MM/yyyy",
  DISPLAY_SHORT: "dd/MM/yy",
  DISPLAY_WITH_TIME: "dd/MM/yyyy hh:mm a",
  API: "yyyy-MM-dd",
};

const toDate = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return isValid(date) ? date : null;
};

export const formatDate = (value, pattern = DATE_FORMAT.DISPLAY) => {
  const date = toDate(value);
  return date ? format(date, pattern) : null;
};

export const formatApiDate = (value) => formatDate(value, DATE_FORMAT.API);

export const formatDisplayDate = (value) => formatDate(value, DATE_FORMAT.DISPLAY);

export const formatDisplayDateOrDash = (value, pattern = DATE_FORMAT.DISPLAY) =>
  formatDate(value, pattern) ?? "—";
